import { FC, useMemo } from "react";

import { CustomColor, Status } from "@portex-pro/ui-components";
import { BrokerContractType } from "api/rest/rfp/brokerBidContractApi/types/BrokerContractType";
import { ResourceKey } from "i18next";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

interface StatusParams {
  color: CustomColor;
  label: ResourceKey;
}

type MappedRfpBrokerStates = "Closed" | "Active" | "Completed";

const paramsPerState: Record<MappedRfpBrokerStates, StatusParams> = {
  Active: {
    color: "green",
    label: "common:active",
  },
  Closed: {
    color: "grey",
    label: "common:closed",
  },
  Completed: {
    color: "blue",
    label: "common:completed",
  },
};

const mapRfpStatusToBrokerState: Record<BrokerContractType["status"], MappedRfpBrokerStates> = {
  ACTIVE: "Active",
  CLOSED: "Closed",
};

interface BrokerRfpStateBadgeViewProps {
  contract: BrokerContractType;
  big?: boolean;
}

const BrokerRfpStateBadgeView: FC<BrokerRfpStateBadgeViewProps> = ({ contract, big = false }) => {
  const { t } = useTranslation("common");

  let state: MappedRfpBrokerStates = mapRfpStatusToBrokerState[contract.status];

  if (state === "Active" && (!contract.is_biddable || DateTime.fromISO(contract.deadline) < DateTime.now())) {
    state = "Completed";
  }

  const [color, label] = useMemo(() => [paramsPerState[state].color, t(paramsPerState[state].label)], [state, t]);

  return (
    <Status light rounded palette={color}>
      {big ? <big>{label}</big> : label}
    </Status>
  );
};

export default BrokerRfpStateBadgeView;
